import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import { translate } from '../../../services/translate';
import ExternalSelect from '../../../components/ExternalSelect';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
}

function TagsDropdown({ value, setValue, zIndex }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getOccurrenceTags() {
        try {
            const tags = await dispatchService.getDropDownOccurrenceTags();
            setItems(tags.map((tag) => {
                return {
                    value: tag.id,
                    label: tag.name,
                    color: tag.color
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getOccurrenceTags();
    }, []);

    return (
        <ExternalSelect
            label={translate('tags')}
            selectedLabel={translate('selectedTags')}
            items={items}
            setValue={setValue}
            value={value}
            multiple={true}
            zIndex={zIndex}
            onRemove={(items) => setValue(items as number[])}
            initialSelectedItems={items.filter(item => value.includes(item.value))}
        />
    );
}

export default TagsDropdown;
